import { Component } from 'react';

/**
 * [suggestion bymyself: could be done using HoCs]
 *
 * A abstract React component that performs legend filter when it detects
 * "legendsFilter" props change.
 *
 * This component does not triggers a component update (a re-render)
 * when a legendsFilter is changed because this is must be resolved
 * with updateLegends() {} callback.
 *
 */
export default class SearchableChart extends Component {
  constructor(props) {
    super(props);
    this.theme = localStorage.getItem('themeActive');
  }

  /**
   * @override
   * Chamando quando o componente está para receber novas props.
   * Se as legendas forem diferente atualiza as legendas.
   */
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { legendsFilter, legendsFilterHandler } = this.props;
    if (nextProps.legendsFilter !== legendsFilter) {
      const filteredLegends = this.filterLegends(nextProps, legendsFilterHandler);
      this.updateLegends(filteredLegends);
    }
  }

  filterLegends(nextProps, legendsFilterHandler) {
    // call function to handle filter
    // and update echarts with new legends.
    const currentLegends = this.getCurrentLegends();

    // {dataset, datasetFilterField, query}
    const filteredLegends = legendsFilterHandler({
      dataset: currentLegends,
      datasetFilterField: 'name',
      query: nextProps.legendsFilter,
    });

    return filteredLegends;
  }

  hasChanged(first, second) {
    if (typeof first === 'object') {
      const firstJson = JSON.stringify(first);
      const secondJson = JSON.stringify(second);

      return firstJson !== secondJson;
    }

    return first !== second;
  }

  /**
   * @override
   * avoiding re-render when legendsFilter change.
   */
  shouldComponentUpdate(nextProps, nextState) {
    const nextPropsKeys = Object.keys(nextProps);

    const estadoMudou = nextPropsKeys
      .filter((nextPropsKey) => nextPropsKey !== 'legendsFilter')
      .some((nextPropsKey) => {
        const changed = this.hasChanged(
          nextProps[nextPropsKey],
          this.props[nextPropsKey],
        );

        return changed;
      });

    return estadoMudou;
  }

  /**
   * get current legends
   */
  getCurrentLegends() { }

  /**
   * updates the legends based on the new filtered legends
   */
  updateLegends(filteredLegends) { }
}
